import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService, GRSSUserRoles } from '../_services/app.service';

@Injectable({
  providedIn: 'root'
})
export class AdminOperatorGuard  {

  constructor(private service: AppService, private router: Router) { }

  // Changed the default code to this for wait(avoid executing the next line) until gets the result.
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.service.currentUser === undefined) {
      return new Promise((resolve, reject) => {
        this.service.CheckAuth().then(e => {
          resolve(this.GetResult(route.data.additionalRoles));
        });
      });
    } else {
      return this.GetResult(route.data.additionalRoles);
    }
  }

  GetResult(additionalRoles): boolean {
    if (this.service.currentUser.userRole === GRSSUserRoles.Admin || this.service.currentUser.userRole === GRSSUserRoles.Operator || this.service.currentUser.userRole === GRSSUserRoles.Compliance) {
      if (this.service.currentUser.userRole === GRSSUserRoles.Compliance) {
        this.service.currentUser.isReadOnly = true;
      }
      return true;
    } else if (additionalRoles) {
      if (additionalRoles[0] === 'staff') {
        return true;
      }
    }

    return false;
  }
}
